module.exports = __webpack_public_path__ + "static/media/icon_pill.d2380ece.svg";